import React from "react";
import DataManagementList from "../DataManagementList/DataManagementList";
import { GeneralStyle } from "./DataManagement.styled";
import PropTypes from "prop-types";

let showSelectedMenuTable = (
  selectedMenu,
  reloadRender,
  setReloadRender,
  setFormTrigger,
  formTrigger,
  valueTab
) => {
  switch (selectedMenu[0]) {
    case "lob":
      return (
        <DataManagementList
          activeLob={true}
          reloadRender={reloadRender}
          setReloadRender={setReloadRender}
          formTrigger={formTrigger}
          setFormTrigger={setFormTrigger}
          valueTab={valueTab}
        />
      );
    case "location":
      return (
        <DataManagementList
          activeSite={true}
          reloadRender={reloadRender}
          setReloadRender={setReloadRender}
          formTrigger={formTrigger}
          setFormTrigger={setFormTrigger}
        />
      );
    default:
      break;
  }
};

const DataManagement = ({
  selectedMenu,
  reloadRender,
  setReloadRender,
  setFormTrigger,
  formTrigger,
  valueTab,
}) => {
  return (
    <GeneralStyle>
      {showSelectedMenuTable(
        selectedMenu,
        reloadRender,
        setReloadRender,
        setFormTrigger,
        formTrigger,
        valueTab
      )}
    </GeneralStyle>
  );
};

export default DataManagement;

DataManagement.propTypes = {
  selectedMenu: PropTypes.array,
  reloadRender: PropTypes.bool,
  setReloadRender: PropTypes.func,
  setFormTrigger: PropTypes.func,
  formTrigger: PropTypes.string,
  valueTab: PropTypes.number,
}


